<template>
<div class="similar_anime_block watching_anime_block">
  <h3>Продолжить просмотр</h3>

    <div class="my-swiper-container" v-if="isMobile">
        <div class="my-swiper-wrapper1">
            <div v-for="anime in watching_list" :key="anime.id" class="my-swiper-slider">
              <router-link :to="'/' + anime.shikimori_id" :title="anime.title">
                <img :src="anime.poster_anime.replace('.me','.one')">
              </router-link>
              <p style="font-family: 'Montserrat',sans-serif;" class="three-dots" :title="anime.title">{{ anime.title }}</p>
            </div>
        </div>
       
        <div class="swiper-pagination"></div>
    </div>

   
    <div class="swiper-container" v-if="!isMobile">
        <div class="swiper-wrapper">
            <div v-for="anime in watching_list" :key="anime.id" class="swiper-slide">
              <router-link :to="'/' + anime.shikimori_id" :title="anime.title">
                <img :src="anime.poster_anime.replace('.me','.one')">
              </router-link>
              <p style="font-family: 'Montserrat';" class="three-dots" :title="anime.title">{{ anime.title }}</p>
            </div>
        </div>
    
        <div class="swiper-pagination"></div>
    </div>
</div>   
</template>



<script>
import axios from 'axios';
import Swiper from '@/shared/lib/third-parties/swiper.js'

export default {
  data() {
    return {
      originUrl: window.location.origin,
      title: "",
      watching_list: [],
      isMobile: false
    };
  },
  created(){
   
    this.getWatchingAnime();
  },
  updated() {
    if(this.isMobileFunc()){
      this.setWidthOfSimilar();
    }
  },
  methods: {
    getWatchingAnime: function(){
      if(localStorage.getItem('password_hash') && localStorage.getItem('user_id')){
        let url = `${window.location.protocol}//${window.location.hostname}/api/getAnimeListByUserId.php?password_hash=${localStorage.getItem('password_hash')}&user_id=${localStorage.getItem('user_id')}`;

        axios
        .get(url)
        .then((response) => {
          if(response.data){
            for(let i = 0;i < response.data.length;i++){
              if (response.data[i].state_of_anime === 'watching') {
                this.watching_list.push(response.data[i]);
              }
              
            }
            

            if(this.isMobileFunc()){
              this.isMobile = true;
              // this.setWidthOfSimilar();
            }else{
              this.isMobile = false;
              setTimeout(function(){
               new Swiper('.swiper-container', {
                slidesPerView: "auto",
                direction: "horizontal",
                touchRatio: 1.0,
                freeMode: true, 
                grabCursor: true
                 
              });
             },20);
            }

          }else{
            console.log('Неверный hash и user_id: ' + response.data);
          }
        })
        .catch((error) => {
          alert(error)
          console.error(error);
        });
      }
    },
    setWidthOfSimilar: function(){
      let swiperWrapper = document.querySelector('.my-swiper-wrapper1');
      let widthOfSimilarImages = 0;
      for(let i = 0;i < this.watching_list.length;i++){
          widthOfSimilarImages += (175 + 30);
      }
      swiperWrapper.style.width = widthOfSimilarImages + 'px';
      return widthOfSimilarImages;
    },
    isMobileFunc: function() {
      if(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
         return true
      } else {
         return false
      }
    }
  }
  
};
</script>

<style>
.my-swiper-container::-webkit-scrollbar {
  display: none !important;           
}

.watching_anime_block {
  width: 100%;
}

.similar_anime_block.watching_anime_block h3{
  display: inline-block;
  text-align: left;
  font-size: 20px;
  border: 1px solid #5555555e;
  border-radius: 5px;
  background: #2a2a2a99;
  padding: 1px 8px;
  margin-bottom: 15px;
  margin-top: 20px;
}


.watching_anime_block .swiper-container {
  margin: 0 !important;
}

@media only screen and (max-width: 768px) {
  .watching_anime_block h3{
    margin-bottom: 5px;
    margin-left: 20px;
    padding-left: 0;
  }


  .my-swiper-wrapper1{
    border-top: 10px solid black;
    border-color: transparent;
    transform: rotateX(180deg);
  }

  .my-swiper-wrapper1:nth-of-type(1) {
      margin-left: 20px;
  }
  
}
</style>